declare namespace $ {

	type $mol_image__uri_shm_hitalama_profile_badge_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_badge['avatar_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_view__sub_shm_hitalama_profile_badge_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_profile_badge extends $mol_view {
		Avatar( ): $mol_image
		avatar_visible( ): readonly(any)[]
		Name( ): $mol_view
		avatar_uri( ): string
		name( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=badge.view.tree.d.ts.map